import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/university/patterns')({

}).lazy(() => import('./patterns.lazy').then((d) => d.Route));
